<div class="pairings-swap">
  <div class="swap-section">
    <h4>Swap Players</h4>
    <div class="row">
      <div class="col-sm-6">
        <label for="swapPlayerA">Player 1</label>
        <select
          id="swapPlayerA"
          class="form-control"
          [(ngModel)]="selectedPlayerA"
          [disabled]="isBusy() || playerOptions().length === 0"
        >
          <option [ngValue]="null">-- Select Player --</option>
          @for (player of playerOptions(); track trackByPlayer($index, player))
          {
          <option [ngValue]="player.slotId">
            {{ player.playerName }}
          </option>
          }
        </select>
        @if (selectedPlayerADetail()) {
        <small class="text-muted">
          {{ selectedPlayerADetail()?.displayDetail }}
        </small>
        }
      </div>
      <div class="col-sm-6">
        <label for="swapPlayerB">Player 2</label>
        <select
          id="swapPlayerB"
          class="form-control"
          [(ngModel)]="selectedPlayerB"
          [disabled]="isBusy() || playerOptions().length === 0"
        >
          <option [ngValue]="null">-- Select Player --</option>
          @for (player of playerOptions(); track trackByPlayer($index, player))
          {
          <option [ngValue]="player.slotId">
            {{ player.playerName }}
          </option>
          }
        </select>
        @if (selectedPlayerBDetail()) {
        <small class="text-muted">
          {{ selectedPlayerBDetail()?.displayDetail }}
        </small>
        }
      </div>
    </div>
    <button
      class="btn btn-primary btn-block m-t-sm"
      [disabled]="!canSwapPlayers()"
      (click)="swapPlayers()"
    >
      <i class="fa fa-exchange"></i> Swap Players
    </button>
  </div>

  <hr />

  <div class="swap-section">
    <h4>Swap Groups</h4>
    <div class="row">
      <div class="col-sm-6">
        <label for="swapGroupA">Group 1</label>
        <select
          id="swapGroupA"
          class="form-control"
          [(ngModel)]="selectedGroupA"
          [disabled]="isBusy() || groupOptions().length === 0"
        >
          <option [ngValue]="null">-- Select Group --</option>
          @for (group of groupOptions(); track trackByGroup($index, group)) {
          <option [ngValue]="group.groupId">
            {{ group.displayName }}
          </option>
          }
        </select>
        @if (selectedGroupADetail()) {
        <small class="text-muted">
          {{ selectedGroupADetail()?.detail }}
        </small>
        }
      </div>
      <div class="col-sm-6">
        <label for="swapGroupB">Group 2</label>
        <select
          id="swapGroupB"
          class="form-control"
          [(ngModel)]="selectedGroupB"
          [disabled]="isBusy() || groupOptions().length === 0"
        >
          <option [ngValue]="null">-- Select Group --</option>
          @for (group of groupOptions(); track trackByGroup($index, group)) {
          <option [ngValue]="group.groupId">
            {{ group.displayName }}
          </option>
          }
        </select>
        @if (selectedGroupBDetail()) {
        <small class="text-muted">
          {{ selectedGroupBDetail()?.detail }}
        </small>
        }
      </div>
    </div>
    <button
      class="btn btn-info btn-block m-t-sm"
      [disabled]="!canSwapGroups()"
      (click)="swapGroups()"
    >
      <i class="fa fa-exchange"></i> Swap Groups
    </button>
  </div>

  <hr />

  <div class="swap-section">
    <h4>History</h4>
    @if (swapHistory().length === 0) {
    <p class="text-muted">No swaps recorded in this session.</p>
    } @else {
    <ul class="list-unstyled swap-history">
      @for (item of swapHistory(); track trackByHistory($index, item)) {
      <li>
        <span class="timestamp">{{ item.timestamp | date : "shortTime" }}</span>
        <span class="description">{{ item.description }}</span>
      </li>
      }
    </ul>
    }
  </div>
</div>
